import { useState } from 'react';
import { useForm } from "react-hook-form";
import { useAuthState } from "../../../utilities/contexts/auth-state-context";
import OrganizationService from '../../../utilities/services/organization-service';
import { enqueueSnackbar } from "notistack";
import { TextTypeInput } from '../../forms';
import { Button } from '../../button/button';
import { useTranslation } from 'react-i18next';
import { createLogger } from '../../../utilities/logger';

const log = createLogger("EditOrganization");

interface EditOrganizationProps {
  onClose: any,
}
const COMPONENT_CLASS = "c-subscriptions";
const FORM_COMPONENT_CLASS = "p-link-create-account";

const EditOrganization: React.FC<EditOrganizationProps> = (props: EditOrganizationProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { t } = useTranslation();
  const [, setSubmitting] = useState<boolean>(false);
  const { state, setState } = useAuthState();

  const onSubmit = async (data: any) => {
    if (data.organizationName && state.organization.id) {
      setSubmitting(true);
      try {
        const org = await OrganizationService.get(state.organization.id);
        if (org) {
          org.name = data.organizationName.trim();
          await OrganizationService.update(org, state.user).then(() => {
            const stateOrg = state.organization;
            stateOrg.name = data.organizationName;
            setState((state) => ({
              ...state, ...{ organization: stateOrg }
            }));
            reset();
            setSubmitting(false);
            log.info("Organization settings saved", {
              organizationId: state.organization.id,
            });
            enqueueSnackbar(t('settings.account.orgUpdated'), { variant: "toast", width: "450px", autoHideDuration: 5000 });
            props.onClose();
          }).catch((e) => {
            log.error("Failed to update organization name", {
              exception: e,
              organizationId: state.organization.id,
            });
            setSubmitting(false);
          });
        }
      } catch (e) {
        log.error("Failed to load organization for rename", {
          exception: e,
          organizationId: state.organization.id,
        });
        setSubmitting(false);
      }
    }
    else {
      setSubmitting(false);
    }
  }
  return (
    <div className={`${COMPONENT_CLASS}`}>
      <div className={`${COMPONENT_CLASS}__wrapper`}>
        <div style={{ width: '90%', marginTop: '2rem' }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={`${FORM_COMPONENT_CLASS}__field`}>
              {errors.organizationName && (
                <div role="alert" className={`${FORM_COMPONENT_CLASS} -error`}>
                  {t('settings.account.confirmOrg')}
                </div>
              )}
              <TextTypeInput
                type='text'
                id='organizationName'
                label={t('forms.orgName')}
                hideLabel={true}
                style={{
                  marginLeft: '0',
                  width: '90%',
                  marginBottom: '1.25rem'
                }}
                registerHook={register}
                registerOptions={{
                  value: state.organization.name,
                  required: true,
                }}
                errorState={errors.organizationName} />
            </div>
          </form>
        </div>
        <div className={'c-login-modal__button-area'} style={{ gap: "50px" }}>
          <Button
            type='link'
            buttonText={t('buttons.btn_cancel')}
            onClick={props.onClose} />
          <Button
            buttonStyle='primary'
            onClick={handleSubmit(onSubmit)}
            buttonText={t('buttons.btn_saveChanges')} />
        </div>
      </div>
    </div >
  );
}

export default EditOrganization;
